import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-white" data-testid="not-found">
      <div className="mx-auto flex max-w-3xl flex-col items-start px-4 py-24 lg:px-6 lg:py-32">
        <div className="font-heading text-7xl font-semibold text-wafa-primary lg:text-9xl">404</div>
        <h1 className="mt-6 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-5xl">
          We couldn't find that page.
        </h1>
        <p className="mt-4 max-w-lg text-base text-wafa-ink/75 lg:text-lg">
          The link may be old, or the page may have moved. Head back home, or tell us what you were
          looking for.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="rounded-md bg-wafa-primary px-5 py-3 text-sm font-semibold text-white hover:bg-wafa-deep">Back to home</Link>
          <Link to="/contact" className="rounded-md border border-wafa-deep/20 px-5 py-3 text-sm font-semibold text-wafa-deep hover:bg-wafa-cream/50">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
